import { contains, curry, path } from "ramda"
import { isNotNullOrEmpty } from "../../validate"

export const isAssociatedState = curry((assoDataPath, { value, forminputdata }) => {
  const mandatoryIDs = ["CHN", "USA", "CAN", "AUS", "JPN", "IND", "TWN"]
  const assoValue = path(assoDataPath, forminputdata) || {}
  const isMandatory = contains(assoValue.id, mandatoryIDs)
  if (isMandatory && !isNotNullOrEmpty(value)) return false

  return true
})

export const isAssociatedCity = curry((assoCountryDataPath, { value, forminputdata }) => {
  const mandatoryIDs = ["CHN"]
  const assoCountryValue = path(assoCountryDataPath, forminputdata) || {}
  const isMandatory = contains(assoCountryValue.id, mandatoryIDs)
  if (isMandatory && !isNotNullOrEmpty(value)) return false

  return true
})
